import { Col, Row } from "antd";
import styles from "./JobDetails.module.css";
import { CiLocationOn, CiLock } from "react-icons/ci";
import { TbWorld } from "react-icons/tb";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import { PiWarningCircle } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";

const JobDetails = ({data={}, loading}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(location.pathname.replace("job", "job-description"));
  };

  return (
    <div className={styles.content_wrap}>
      <div className={styles.title}>{data.JobDescription?.job_title}</div>
      <Row gutter={[12, 12]} className={styles.column_wrap}>
        <Col xs={24} sm={24} md={24} lg={14} xl={12}>
          <div className={styles.description}>{data.JobDescription?.job_expectation}</div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={10} xl={12}>
          <div className={styles.details_wrap}>
            <div className={styles.cell_1}>
              <CiLocationOn />
              {data.employment_type}
            </div>
            <div className={styles.cell_2}>
              <span>IndexScore:</span>
              {data.min_index_core}
              {"+"}
            </div>
            <div className={styles.cell_3}>
              <TfiWorld />
              {data.division}
            </div>
            <div className={styles.cell_4}>
              {" "}
              Purpose:{data.purpose ? data.purpose : <CiLock />}
            </div>
          </div>
        </Col>
      </Row>
      <div className={styles.show_more} onClick={handleClick}>
        <PiWarningCircle />
        View/edit full job description
      </div>
    </div>
  );
};

export default JobDetails;
